<phx-select
    #selectComponent
    [items]="connectionTypeArray()"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [optionLabel]="'label'"
    [optionValue]="'value'"
    [dataTestId]="props.dataTestId"
    (onFilter)="onFilter($event)"
>
</phx-select>
